import React from 'react';
import { VoicePreference } from '../../services/cxone-sdk.service';
import { CXoneState } from '../../types';

export interface CXoneContextValue extends CXoneState {
  audioRef: React.RefObject<HTMLAudioElement>;
  hasSessionConflict: boolean;
  needsVoicePreference: boolean;
  voicePreference: VoicePreference | null;
  isSessionInvalid: boolean;
  isReconnecting: boolean;
  initializeWithVoicePreference: (preference: VoicePreference) => Promise<void>;
  disconnect: () => Promise<void>;
  forceLogoutAndReconnect: () => Promise<void>;
  clearSessionConflict: () => void;
  handleSessionError: (error: Error | string) => void;
  reconnect: () => Promise<void>;
}

export const initialCxoneState: CXoneState = {
  isInitialized: false,
  isConnecting: false,
  isConnected: false,
  connectionError: null,
  connectionProgress: null,
};

export interface CxoneSessionRefs {
  initializedRef: React.MutableRefObject<boolean>;
  initializingRef: React.MutableRefObject<boolean>;
  voicePreferenceRef: React.MutableRefObject<VoicePreference | null>;
  previousTokenRef: React.MutableRefObject<string | null>;
}
